import { render } from "./index.vue?vue&type=template&id=2b29eb01"
import script from "./search-input.ts?vue&type=script&lang=js"
export * from "./search-input.ts?vue&type=script&lang=js"

import "./search-input.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script